import Axios from 'axios';

export default Axios.create({
    baseURL: 'api/',
});